import React, { Component, Fragment, createRef } from 'react';
import Axios from 'axios';
import { Form, Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import Loader from 'react-loader-spinner';
import { isRequiredSelection } from './helpers/Validation';

class FormularyLookup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            states: null,
            submitted: false,
            healthPlansAvailable: null,
            drugSelection: 4636,
            healthPlan: null,
            healthPlanList: null,
            coverageType: null,
            loadingHealthPlans: false,
            stateId: null,
            userCoverage: null,
            healthPlanName: null
        }

        this.baseState = this.state
    }

    componentDidMount() {
        // These numbers relate to the drug size in the api
        // largeCapsules = 4636;
        // smallCapsules = 3887;
        // const urlParams = new URLSearchParams(window.location.search);
        // const drugSelection = urlParams.get('drugSelection');
        // this.setState({
        //     ...this.state,
        //     drugSelection: drugSelection ? drugSelection : false
        // })
    }

    updateHiddenInput = (name, value, event=null) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    getStates = async () => {
        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        reactState.setState({
            loadingStates: true
        });
        await Axios({
            method: 'post',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            url: url + 'api/third_party',
            data: "https://api.fingertipformulary.com/states.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e"
        })
        .then(function (res) {
            let stateList = [];
            const states = new Promise((resolve, reject) => {
                {res.data.map((state, index) => (
                    stateList.push(state.state)
                ))}
                resolve();
            });
            states.then(() => {
                reactState.setState({
                    states: stateList,
                    loadingStates: false
                });
            });
        });
    }

    getHealthPlans = async (stateId) => {
        const reactState = this;
        const { coverageType } = reactState.state;
        reactState.setState({
            loadingHealthPlans: true
        });
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        let healthPlans;

        switch(coverageType) {
            case "Commercial":
                healthPlans = '1,4,16,13,9,14,11';
                break;
            case "Medicare":
                healthPlans = '19,17,5,6,7,18';
                break;
            case "State Medical":
                healthPlans = '10';
                break;
            case "Health Exchange":
                healthPlans = '13,14';
                break;
            case "Managed Medicaid":
                healthPlans = '3';
                break;
            default:
                // All
                healthPlans = '1,4,16,13,9,14,11,19,17,5,6,7,18,3,10';
                break;
        }
        //console.log("trying https://api.fingertipformulary.com/health_plans.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&state_id=" + stateId + "&health_plan_types=" + healthPlans)
        await Axios({
            method: 'post',
            url: url + 'api/third_party',
            data: "https://api.fingertipformulary.com/health_plans.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&state_id=" + stateId + "&health_plan_types=" + healthPlans
        }).then(function (res) {
            reactState.setState({
                stateId: stateId,
                healthPlansAvailable: res.data,
                loadingHealthPlans: false
            });
        });
    }

    isUserCovered = async (values) => {
        const reactState = this;
        const { drugSelection, healthPlan } = values;
        // To avoid overusing setstate ID & name are barrelled
        let healthPlanId = healthPlan.split("|")[0];
        let healthPlanName = healthPlan.split("|")[1];
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        try {
            //console.log("trying https://api.fingertipformulary.com/coverage_statuses/status.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&drug_id=" + drugSelection + "&plan_ids=" + healthPlanId);
            await Axios({
                method: 'post',
                url: url + 'api/third_party',
                data: "https://api.fingertipformulary.com/coverage_statuses/status.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&drug_id=" + drugSelection + "&plan_ids=" + healthPlanId
            }).then(function (res) {
                // determine if user is covered
                let covered;
                res.data.filter(result => {
                    if(result.formulary_detail.pharmacy_status === "Not Covered") {
                        covered = "no";
                    } else {
                        covered = "yes";
                    }
                    reactState.setState({
                        userCoverage: covered,
                        healthPlanName: healthPlanName,
                        submitted: true
                    });
                    return;
                });
            });
        } catch {
            reactState.setState({
                userCoverage: "no-result",
                submitted: true
            });
        }
    }

    resetForm = (form) => {
        this.setState(this.baseState);
        this.toTop.current.scrollIntoView({ behavior: "smooth" });
        return form.reset();
    }
    toTop = createRef();

  render() {
    const {
        states,
        submitted,
        healthPlanName,
        healthPlansAvailable,
        userCoverage,
        coverageType,
        loadingHealthPlans,
        loadingStates
    } = this.state;
    const largeCapsules = 4636;
    const smallCapsules = 3887;

    {/* TODO */}
    const drugSelection = largeCapsules;

    return (
        <Fragment>
            <div className="acadia-form">
                <div id="formTop">
                    <Form
                        onSubmit={this.isUserCovered}
                    >
                    {({ form, values, submitting, pristine, handleSubmit }) => (
                        <form>
                            <div className="form-group">
                                {!drugSelection && (
                                    <Fragment>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="capsule-link" style={{color: "#fff"}}>
                                                    NUPLAZID<sup>®</sup> (pimavanserin)
                                                    <button
                                                        style={{display: "inline-block", marginLeft: "10px"}}
                                                        className="button white"
                                                        type="button"
                                                        onClick={(e) => this.updateHiddenInput("drugSelection", largeCapsules)}
                                                    >
                                                        34 MG CAPSULES
                                                    </button>
                                                </div>
                                            </div>
                                            {/*
                                            <div className="col-sm-6">
                                                <div className="capsule-link" style={{color: "#fff"}}>
                                                    NUPLAZID<sup>®</sup> (pimavanserin)
                                                    <button
                                                        style={{display: "inline-block", marginLeft: "10px"}}
                                                        className="button white"
                                                        type="button"
                                                        onClick={(e) => this.updateHiddenInput("drugSelection", smallCapsules)}
                                                    >
                                                        10 MG CAPSULES
                                                    </button>
                                                </div>
                                            </div>
                                            */}
                                        </div>
                                    </Fragment>
                                )}

                                {drugSelection && (
                                    <div className="row">
                                        <div className="col-lg-4 col-sm-7">
                                        <div className="row spacer-small" />
                                            <Field className="form-control full-width-input" name="drugSelection" component="input" type="hidden" defaultValue={drugSelection} />
                                            <div className="form-group">
                                                <Field name="coverageType" component="select" className="select-css" validate={isRequiredSelection}>
                                                    {({ input, meta }) => (
                                                        <Fragment>
                                                            <label className={"full-width-label text-left " + (meta.error && meta.touched ? "error" : "")}>
                                                                Select coverage type*
                                                            </label>
                                                            <select {...input} className="select-css">
                                                                <option name="coverageType" defaultValue="">Select</option>
                                                                <option name="coverageType" defaultValue="All (recommended)">All (recommended)</option>
                                                                <option name="coverageType" defaultValue="Commercial">Commercial</option>
                                                                <option name="coverageType" defaultValue="Medicare">Medicare</option>
                                                                <option name="coverageType" defaultValue="State Medical">State Medical</option>
                                                                <option name="coverageType" defaultValue="Health Exchange">Health Exchange</option>
                                                                <option name="coverageType" defaultValue="Managed Medicaid">Managed Medicaid</option>
                                                            </select>
                                                        </Fragment>
                                                    )}
                                                </Field>
                                                <div className="row spacer-medium" />
                                                <OnChange name="coverageType">
                                                    {(value, previous) => {
                                                        // This ensures the user resets if they randomly
                                                        // pass this point then change states again
                                                        form.change('stateId', '');
                                                        form.change('healthPlan', '');
                                                        this.setState({
                                                            ...this.state,
                                                            coverageType: value,
                                                            healthPlansAvailable: false // Reset health plans if the user changes coverage
                                                        });
                                                        this.getStates()
                                                    }}
                                                </OnChange>

                                                <div className="relative">
                                                    <Field name="stateId" component="select" className="select-css" validate={isRequiredSelection}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className={"full-width-label text-left " + (meta.error && meta.touched ? "error" : "")}>
                                                                    Select state*
                                                                </label>
                                                                <select {...input} className="select-css" disabled={!states}>
                                                                <option name="stateId" defaultValue="">Select</option>
                                                                    {states && states.map((state, index) => {
                                                                        return (<option key={index} name="states" value={state.id}>{state.name}</option>);
                                                                    })}
                                                                </select>
                                                                {loadingStates && (
                                                                    <Loader
                                                                        type="ThreeDots"
                                                                        color="#5FA5BB"
                                                                        height={100}
                                                                        width={100}
                                                                        className="loading-icon"
                                                                    />
                                                                )}
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>

                                                <div className="row spacer-medium" />
                                                <OnChange name="stateId">
                                                    {(value, previous) => {
                                                        form.change('healthPlan', '');
                                                        this.getHealthPlans(value);
                                                    }}
                                                </OnChange>

                                                <div className="relative">
                                                    <Field name="healthPlan" component="select" className="select-css" validate={isRequiredSelection}>
                                                        {({ field, input, meta }) => (
                                                            <Fragment>
                                                                <label className={"full-width-label text-left " + (meta.error && meta.touched ? "error" : "")}>
                                                                    Select health plan*
                                                                </label>
                                                                <select {...input} className="select-css" disabled={!healthPlansAvailable}>
                                                                    <option name="healthPlan" defaultValue={false}>Select</option>
                                                                    {healthPlansAvailable && healthPlansAvailable.map((item, index) => {
                                                                        const {displayid, webname} = item.health_plan;
                                                                        return (<option key={index} name="healthPlan" value={displayid + '|' + webname}>{webname}</option>);
                                                                    })}
                                                                    {Array.isArray(healthPlansAvailable) && !healthPlansAvailable.length && (
                                                                        <option key="state-1" name="healthPlan" value="">Not available</option>
                                                                    )}
                                                                </select>
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                    {loadingHealthPlans && (
                                                        <Loader
                                                            type="ThreeDots"
                                                            color="#5FA5BB"
                                                            height={100}
                                                            width={100}
                                                            className="loading-icon"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            
                                            <div className="text-left">
                                                <div class="row spacer-medium desktop">&nbsp;</div>
                                                    {/*<a href="/healthcare-providers/coverage-tools" className="button blue button-spacing back" style={{margin: "0 5px"}} disabled={loadingHealthPlans || submitting || pristine}>
                                                        <span>
                                                            <svg width="0.9em" height="0.9em" viewBox="0 0 16 16" className="bi bi-chevron-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                                            </svg>
                                                        </span>
                                                        Previous step
                                                    </a>*/}
                                                    <FormSpy subscription={{ values: true }}>

                                                        {({ values }) => {
                                                            console.log("values", values);
                                                            return(<button type="submit"
                                                                onClick={handleSubmit}
                                                                className={"button blue button-spacing formulary-lookup relative forward " + (submitting ? "loading" : "")}
                                                                style={{margin: "0 5px"}}
                                                                disabled={(loadingHealthPlans || submitting || values.healthPlan === "")}
                                                            >
                                                                GET RESULTS 
                                                                {submitting && (
                                                                    <Loader
                                                                        type="ThreeDots"
                                                                        color="#FFF"
                                                                        height={100}
                                                                        width={100}
                                                                        className="loading-icon"
                                                                        
                                                                    />
                                                                )}
                                                            </button>)
                                                        }}
                                                    </FormSpy>
                                                </div>
                                                <p className="thisinform">This information is intended as a guide. Coverage and costs may differ between private and government insurance plans, and are subject to change. Please check with the health plan to confirm coverage for individual patients.</p>
                                                <div class="row spacer-large">&nbsp;</div>
                                            </div>
                                        <div className="col-lg-7 offset-lg-1 col-sm-7">

                                            {!userCoverage && (
                                                <Fragment>
                                                    <div class="text-right-lg">
                                                        <img src="/images/woman-stroking-cat-in-heart.jpg" className="heart" alt="Actor portrayal of a woman sitting on her couch and petting her cat" />
                                                        <p className="heart-actor-portrayals">actor<br/>portrayal</p>
                                                    </div>
                                                </Fragment>
                                            )}

                                            {userCoverage === "yes" && submitted &&  (
                                                <Fragment>
                                                    <div className="result">
                                                        <div className="row spacer-large desktop" />
                                                        <p className="font-20 medium-font blue-font">GREAT NEWS!</p>
                                                        {coverageType === "All (recommended)" && (
                                                            <p className="font-20">It looks like {healthPlanName} covers NUPLAZID<sup>®</sup> (pimavanserin).<br className="desktop" /></p>
                                                        )}
                                                        {(coverageType === "Commercial" || coverageType === "Medicare" || coverageType === "State Medical" || coverageType === "Health Exchange" || coverageType === "Managed Medicaid") && (
                                                            <p className="font-20">It looks like {healthPlanName} covers this prescription. <br className="desktop" />
                                                                Prior authorization may be required.</p>
                                                        )}
                                                        {coverageType === "Commercial" && (
                                                            <p className="font-20">Your patients might qualify for a <b>$0 co-pay.<sup>&dagger;</sup></b></p>
                                                        )}
                                                        {coverageType === "All (recommended)" && (
                                                            <p>For more details, call Acadia Connect<span className="trade">&reg;</span> at  <a href="tel:+18447372223" className="no-underline nobr">1-844-737-2223</a>, Monday through Friday, 8:00 am-8:00 pm ET.</p>
                                                        )}
                                                        {(coverageType === "Commercial" || coverageType === "Medicare" || coverageType === "State Medical" || coverageType === "Health Exchange" || coverageType === "Managed Medicaid") && (
                                                            <p>For more details, call Acadia Connect<span className="trade">&reg;</span> at  <a href="tel:+18447372223" className="no-underline nobr">1-844-737-2223</a>, Monday through Friday, 8:00 am-8:00 pm ET, or reach out to your Patient Access Manager.</p>
                                                        )}
                                                        {coverageType === "Commercial" && (
                                                            <p><sup><span className="hang-left-6">&dagger;</span></sup>Acadia Connect <a class="underline-link" href="/nuplazid/pdf/program-details-and-patient-eligibility.pdf" target="_blank">patient eligibility and terms and conditions</a> apply.</p>
                                                        )}
                                                    </div>
                                                </Fragment>
                                            )}

                                            {userCoverage === "no" && submitted &&  (
                                                <Fragment>
                                                    <div className="result">
                                                        <div className="row spacer-large desktop" />
                                                        <p className="font-20 medium-font blue-font uppercase">{healthPlanName} does not cover your prescription.</p>
                                                        <p className="font-20">But don’t worry, there are still coverage options for your patient.</p>
                                                        {coverageType === "All (recommended)" && (
                                                            <p>For more details, call Acadia Connect<span className="trade">&reg;</span> at  <a href="tel:+18447372223" className="no-underline nobr">1-844-737-2223</a>, Monday through Friday, 8:00 am-8:00 pm ET, or reach out to your Patient Access Manager to see how we can help.</p>
                                                        )}
                                                        {(coverageType === "Commercial" || coverageType === "Medicare" || coverageType === "State Medical" || coverageType === "Health Exchange" || coverageType === "Managed Medicaid") && (
                                                            <p>For more details, call Acadia Connect<span className="trade">&reg;</span> at  <a href="tel:+18447372223" className="no-underline nobr">1-844-737-2223</a>, Monday through Friday, 8:00 am-8:00 pm ET, or reach out to your Patient Access Manager.</p>
                                                        )}
                                                    </div>
                                                </Fragment>
                                            )}


                                            {userCoverage === "no-result" && submitted &&  (
                                                <Fragment>
                                                    <div className="result">
                                                        <div className="row spacer-large desktop" />
                                                        <p>Please try filling out the form again so we can get you the results you need. A dedicated Acadia Connect Care Coordinator is also here to help and only a phone call away. If you have questions, connect with us at <span className="nobr">1-844-737-2223</span> Monday through Friday 8:00 AM - 8:00PM EST.</p>
                                                    </div>
                                                </Fragment>
                                            )}

                                        </div>
                                        <div className="row spacer-large" />
                                    </div>
                                )}
                            </div>
                            {process.env.NODE_ENV === "development" && (
                                <pre style={{marginTop: "50px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
                            )}
                        </form>
                    )}
                    </Form>
                </div>
            </div>
        </Fragment>
    );
  }
}



export default FormularyLookup;
